import { ChevronDown } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import iconMap from "./icon";

interface MenuItemProps {
  icon: string;
  label: string;
  isActive?: boolean;
  hasSubMenu?: boolean;
  defaultOpen?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  route?: string;
}

const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  label,
  isActive = false,
  hasSubMenu = false,
  defaultOpen = false,
  onClick,
  children,
  route,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const IconComponent = iconMap[icon];

  // Abre o submenu quando a rota atual e de um filho, sem forcar o fechamento
  // depois disso -- o usuario continua podendo recolher na mao.
  useEffect(() => {
    if (defaultOpen) setIsOpen(true);
  }, [defaultOpen]);

  const handleClick = () => {
    if (hasSubMenu) {
      setIsOpen(!isOpen);
    }

    if (onClick) onClick();
  };

  const menuContent = (
    <>
      {IconComponent && (
        <IconComponent
          size={20}
          className={`
          mr-3 
          ${
            isActive
              ? "text-primary dark:text-primary-foreground"
              : "text-muted-foreground group-hover:text-foreground dark:text-gray-400 dark:group-hover:text-gray-200"
          }
        `}
        />
      )}
      <span className="grow text-sm font-medium">{label}</span>
      {hasSubMenu && (
        <ChevronDown
          size={16}
          className={`
            transform transition-transform duration-200 
            ${isOpen ? "rotate-180" : ""} 
            ${
              isActive
                ? "text-primary dark:text-primary-foreground"
                : "text-muted-foreground group-hover:text-foreground dark:text-gray-400 dark:group-hover:text-gray-200"
            }
          `}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        />
      )}
    </>
  );

  return (
    <div className="relative">
      {route ? (
        <Link
          to={route}
          className={`
            flex items-center px-4 py-2.5 cursor-pointer transition-all duration-200 ease-in-out
            rounded-lg my-0.5 group
            ${
              isActive
                ? "bg-primary/10 text-primary dark:text-white"
                : "text-muted-foreground hover:text-foreground dark:text-gray-400 dark:hover:text-gray-200"
            }
          `}
          onClick={handleClick}
        >
          {menuContent}
        </Link>
      ) : (
        <div
          className={`
            flex items-center px-4 py-2.5 cursor-pointer transition-all duration-200 ease-in-out
            rounded-lg my-0.5 group
            ${
              isActive
                ? "bg-primary/10 text-primary dark:text-white"
                : "text-muted-foreground hover:text-foreground dark:text-gray-400 dark:hover:text-gray-200"
            }
          `}
          onClick={handleClick}
        >
          {menuContent}
        </div>
      )}

      {hasSubMenu && isOpen && (
        <div className="mt-1 ml-4 pl-4 border-l border-border dark:border-gray-700">
          {children}
        </div>
      )}
    </div>
  );
};

export default MenuItem;
